<template>
  <div id="user-rights">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
          ref="formselect"
          :model="formselect"
          label-width="100px"
          class="queryform_div"
        >
          <el-row :gutter="24">
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('desc.userName')">
                <el-input
                  v-model="formselect.queryString"
                  size="small"
                    style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('desc.roleName')">
                <el-select
                  v-model="formselect.role"
                  :placeholder="$t('desc.select')"
                  size="small"
                   style="width: 100%"
                >
                  <el-option
                    :value="$t('desc.all')"
                    :label="$t('desc.all')"
                  ></el-option>
                  <el-option
                    v-for="(item, index) in RoleList"
                    :key="index"
                    :label="item.displayName"
                    :value="item.normalizedName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('title.accountType')">
                <el-select
                  v-model="formselect.accountType"
                  :placeholder="$t('desc.select')"
                  size="small"
                   style="width: 100%"
                >
                  <el-option value="" :label="$t('desc.all')"></el-option>
                  <el-option value="system" :label="$t('desc.systemAccount')"></el-option>
                  <el-option value="sso" :label="$t('desc.ssoAccount')"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
              <el-button
                @click="getUserList('search')"
                type="primary"
                size="small"
                >{{ $t("button.query") }}</el-button
              >
              <el-button @click="reset" size="small">{{
                $t("button.reset")
              }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <template>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="add"
            style="margin-bottom: 10px"
            v-if="hasCreateAuth"
            >{{ $t("button.createUser") }}
          </el-button>
          <el-button
              type="default"
              icon="el-icon-download"
              style="margin-bottom: 10px"
              @click="exportUserList()"
              :loading="loading"
              v-if="hasExportAuth"
              >{{ $t("button.exportAll") }}</el-button
            >
          <div class="tableDiv">
          <el-table :data="userInfoList" stripe style="width: 100%" :empty-text="$t('desc.noData')">
            <el-table-column
              type="index"
              :label="$t('title.serialNumber')"
              width="60"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="userName"
              :label="$t('title.account')"
              min-width="20%"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('desc.userName')"
              min-width="12%"
            >
            </el-table-column>
            <el-table-column
              prop="roleNameDis"
              :label="$t('desc.roleName')"
              min-width="10%"
            >
            </el-table-column>
            <!-- <el-table-column prop="UserDept" label="部门" min-width="19%">
                        </el-table-column> -->
            <el-table-column
              prop="emailAddress"
              :label="$t('title.emailAddress')"
              min-width="20%"
            >
            </el-table-column>
            <el-table-column
              prop="mobilePhone"
              :label="$t('title.mobilePhone')"
              min-width="12%"
            >
            </el-table-column>
            <el-table-column
              prop="accoutType"
              :label="$t('title.accountType')"
              min-width="12%"
            >
            <template slot-scope="scope">
              <label>
                {{ scope.row.accountType == 'sso'?$t('desc.ssoAccount'):$t('desc.systemAccount')}}
              </label>
            </template>
            </el-table-column>
            <el-table-column
              prop="isLocked"
              :label="$t('title.isLocked')"
              min-width="12%"
            >
              <template slot-scope="scope">
                <label>{{ $t("desc." + scope.row.isLocked) }}</label>
              </template>
            </el-table-column>
            <el-table-column
              prop="isActive"
              :label="$t('title.isActive')"
              min-width="12%"
            >
             <template slot-scope="scope">
                  <label v-if="scope.row.isActive ">{{ $t("desc.yes") }}</label>
                  <label v-else
                    >{{ $t("desc.no") }}</label
                  >
                </template>
            </el-table-column>
            <el-table-column
              :label="$t('title.operate')"
              width="160"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="warning"
                  icon="el-icon-refresh"
                  :title="$t('title.resetPassword')"
                  circle
                  size="mini"
                  :disabled="
                    scope.row.userName.indexOf('gwApiUser') >= 0 || scope.row.userName.indexOf(loginUserName) >= 0? true : false
                  "
                  v-if="hasResetPasswordAuth && scope.row.accountType!='sso'"
                  @click="resetPassword(scope.row)"
                >
                </el-button>
                <el-button
                  type="warning"
                  icon="el-icon-unlock"
                  :title="$t('title.relieveLock')"
                  circle
                  size="mini"
                  :disabled="
                    scope.row.userName.indexOf('gwApiUser') >= 0 || scope.row.userName.indexOf(loginUserName) >= 0 ? true : false
                  "
                  v-if="hasRelieveLockAuth && scope.row.isLocked == '是'"
                  @click="relieveLock(scope.row)"
                >
                </el-button>
                <el-button
                  :type="scope.row.userName.indexOf('gwApiUser') >= 0 || scope.row.userName.indexOf(loginUserName) >= 0 ? 'info' : 'primary'"
                  icon="el-icon-edit"
                  :title="$t('button.update')"
                  circle
                  size="mini"
                  :disabled="
                    scope.row.userName.indexOf('gwApiUser') >= 0 || scope.row.userName.indexOf(loginUserName) >= 0 ? true : false
                  "
                  v-if="hasUpdateAuth"
                  @click="editInfo(scope.row)"
                ></el-button>

                <el-switch
                  
                  v-model="scope.row.isActive"
                  :active-color="activeColor"
                  :inactive-color="activeColor1"
                  :title="$t('title.isActive')"
                  @change="activeSubmit(scope.row)"
                   v-if ="hasUserActive"
                  :disabled="
                    scope.row.userName.indexOf('gwApiUser') >= 0 || scope.row.userName.indexOf(loginUserName) >= 0 ? true : false
                  "
                  >
                  
                </el-switch>

                <template>
                  <el-popconfirm
                    placement="top"
                    :confirmButtonText="$t('button.delete')"
                    :cancelButtonText="$t('button.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('title.confirmDelete')"
                    v-if="hasDeleteAuth"
                    @confirm="deleteEleById(scope.row.id)"
                  >
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      :title="$t('button.delete')"
                      circle
                      size="mini"
                      slot="reference"
                      :disabled="
                        scope.row.userName.indexOf('gwApiUser') >= 0|| scope.row.userName.indexOf(loginUserName) >= 0
                          ? true
                          : false
                      "
                    ></el-button>
                  </el-popconfirm>
                </template>
                <el-button
                  type="primary"
                  :title="$t('desc.sfaEquipmentList')"
                  icon="el-icon-document-copy"
                  circle
                  size="mini"
                  @click="showSfaDevice(true, scope.row)"
                ></el-button>
                <el-switch
                  v-model="scope.row.syncSfaEnable"
                  :active-color="activeColor"
                  :inactive-color="activeColor1"
                  :title="$t('desc.isSyncSfaAuth')"
                  @change="updateSyncSfaEnable(scope.row)"
                   v-if ="hasSyncSfaAuth"
                  :disabled="
                    scope.row.userName.indexOf('gwApiUser') >= 0 || scope.row.userName.indexOf(loginUserName) >= 0 ? true : false
                  "
                  >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="pagination.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="prev, pager, next,sizes"
            :total="pagination.totalPage"
            style="text-align: center; margin-top: 10px"
          >
          </el-pagination>
          </div>
        </template>
      </el-main>
    </el-scrollbar>
    <el-dialog
      :title="title"
      v-if="dialogAddUser"
      :visible.sync="dialogAddUser"
      width="900px"
      top="5vh"
    >
      <el-form
        ref="userformref"
        :model="userform"
        label-width="120px" 
        :rules="rules"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item :label="$t('desc.NO')">
              <el-input
                v-model="userform.id"
                :disabled="true"
                :placeholder="$t('desc.automaticallyCreation')"
                style="width: 280px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('title.accountType')"
            prop="accountType"
            :rules="[
                {
                  required: true,
                  message: $t('tips.needed'),
                  trigger:  ['change','blur'],
                },
              ]"
            >
              <el-select
                v-model="userform.accountType"
                :placeholder="$t('desc.select')"
                size="small"
                style="width: 280px"
              >
                <el-option value="system" :label="$t('desc.systemAccount')"></el-option>
                <el-option value="sso" :label="$t('desc.ssoAccount')"></el-option>
                <el-option value="emcCustomer" :label="$t('desc.emcCustomer')"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="userform.accountType=='emcCustomer'">
            <el-form-item :label="$t('title.emcName')"
            prop="emcStationProject"
            >
              <el-select
                v-model="userform.emcStationProject"
                :placeholder="$t('desc.select')"
                size="small"
                style="width: 280px"
              >
                <el-option v-for="item in emcCustomerList"
                    :key="item.id"
                    :label="item.projectName"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              :label="$t('title.account')"
              prop="userName"
              :rules="[
                {
                  required: true,
                  message: $t('tips.enterAccount'),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-if="title == $t('button.createUser')"
                v-model="userform.userName"
                style="width: 280px"
              ></el-input>
              <el-input
                v-else
                disabled
                v-model="userform.userName"
                style="width: 280px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('desc.userName')"
              prop="name"
              :rules="[
                {
                  required: true,
                  message: $t('tips.enterUserName'),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="userform.name" style="width: 280px"></el-input>
              
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              :label="$t('title.emailAddress')"
              prop="emailAddress"
              :rules="[
                {
                  required: true,
                  message: $t('tips.enterEmail'),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="userform.emailAddress"
                style="width: 280px"
              ></el-input>
              <el-input
                value="1"
                style="position: fixed; bottom: -9999px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="title == $t('button.createUser') && userform.accountType !='sso'"
              :label="$t('desc.password')"
              prop="password"
            >
              <el-input
                type="password"
                style="position: fixed; bottom: -9999px"
              ></el-input>
              <el-input
                v-model="userform.password"
                show-password
                style="width: 280px"
              ></el-input>
              <!-- <el-input
                              v-else
                              placeholder="请输入新密码，默认为空则不修改"
                              v-model="userform.password"
                              show-password
                              style="width: 280px"
                            ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('title.mobilePhone')" prop="mobilePhone">
              <el-input
                maxLength="11"
                v-model="userform.mobilePhone"
                style="width: 280px"
              ></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item :label="$t('desc.department')" prop="department">
              <el-select 
                v-model="userform.department"
                :placeholder="$t('desc.select')"
                
              >
                <el-option
                  value="factory"
                  :label="$t('desc.factory')"
                ></el-option>
                <el-option
                  value="headquarters"
                  :label="$t('desc.headquarters')"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item :label="$t('desc.roleName')">
              <div class="tableDiv">
              <el-table
                :data="RoleTable"
                ref="RoleTable"
                stripe 
                :empty-text="$t('desc.noData')"
              >
                <el-table-column :label="$t('title.operate')" width="100px">
                  <template slot-scope="scope">
                    <el-button
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      type="danger"
                      @click="delBuildRow(scope.$index, scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('title.selectRole')"
                  min-width="35%"
                >
                  <template slot-scope="scope">
                    <el-select
                    filterable
                      v-model="scope.row.normalizedName"
                      :placeholder="$t('desc.select')"
                      @change="selectChange(scope.row)"
                    >
                      <el-option
                        v-for="(item, index) in RoleList"
                        :key="index"
                        :label="item.displayName"
                        :value="item.normalizedName"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
              </div>
              <el-button
                v-show="isShowAddBtn"
                class="el-icon-plus"
                @click.prevent="addBuildRow()"
                style="background: rgba(0,0,0,0);"
              ></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item style="margin-left: 120px">
              <el-button type="success" @click="onSubmit()">{{
                $t("button.confirm")
              }}</el-button>
              <el-button @click="dialogAddUser = false">{{
                $t("button.cancel")
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
    :title="$t('desc.sfaEquipmentList')"
    :visible.sync="dialogSfaDevice"
    v-if="dialogSfaDevice"
    width="80%"
    top="5%"
    class="abow_dialog"
  >
    <template>
      <div class="DBDiv">
        <div class="tableDiv">
          <el-form ref="formBind">
            <el-table
              :data="sfaDeviceList"
              ref="CCNTable"
              stripe
              class="formSTable ccntable"
              :empty-text="$t('desc.noData')"
              :height="CCNheight"
              v-loading="deviceTableLoading"
            >
              <el-table-column
                type="index"
                :label="$t('title.serialNumber')"
                width="60"
              >
              </el-table-column>
              <el-table-column
                :label="$t('desc.airCompressorSN')"
                width="100px"
                prop="dsn"
              >
              </el-table-column>
              <el-table-column
                prop="serviceType"
                :label="$t('title.airCompressorService')"
                width="200px"
              >
              </el-table-column>
              <el-table-column
                prop="modelId"
                :label="$t('title.airCompressorType')"
                width="300px"
              >
              </el-table-column>
              <el-table-column
                prop="customerName"
                :label="$t('desc.customer')"
                width="300px"
              >
              </el-table-column>
            </el-table>
            <el-pagination
            background
            :page-size="devicePagination.pageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="devicePagination.current"
            @current-change="deviceHandleCurrentChange"
            @size-change="deviceHandleSizeChange"
            layout="prev, pager, next,sizes"
            :total="devicePagination.totalPage"
            style="text-align: center; margin-top: 10px"
          >
          </el-pagination>
          </el-form>
        </div>
      </div>
    </template>
  </el-dialog>
  </div>
</template>

<script>
import {
  getUser,
  UpdateUser,
  GetUserRoleDatapermission,
  UpdateRoleDataPermissionList,
  addUser,
  deleteUser,
  getAllRole,
  getRoles,
  getFactoryAlls,
  GetBuildingAlls,
  getLabAll,
  GetUserRoleListDatapermission,
  resetPassword,
  getUserByDto,
  authOperationCheck,
  relieveLock,
  dateFormat,
  exportExcelNew,
  updateSyncSfaEnable,
  getSfaUserBindDevices,
  getStationProjectList,
} from "../../api/api";
import {
  delItemFormLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage"
import { mapState, mapGetters } from "vuex";

export default {
  name: "User_rights",
  data() {
    var validatePass1 = (rule, value, callback) => {
      var yanzheng = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(
        value
      );
      if (!yanzheng && value) {
        return callback(
          new Error(
              this.$t("tips.pwdTips")
          )
        );
      } else {
        callback();
      }
    };
    return {
      rules: {
        password: [{ validator: validatePass1, trigger: "change" }],
      },
      title: "",
      dialogAddUser: false,
      dialogEditUser: false,
      dialogEditPermission: false,
      dialogSfaDevice: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasResetPasswordAuth: false,
      hasRelieveLockAuth: false,
      hasUserActive:false,
      hasSyncSfaAuth:false,
      total: 0,
      userInfoList: [],
      factorylist: [],
      buildinglist: [],
      lablist: [],
      allData: [],
      formselect: {
        queryString: "",
      },
      userform: {
        userName: "",
        password: "",
        dept: "",
        emailAddress: "",
        mobilePhone: "",
        department:'',
        isActive: true,
        accountType:"",
        emcStationProject: ""
      },
      optionDept: [
        {
          value: "选项1",
          label: "商务部",
        },
        {
          value: "选项2",
          label: "软件开发部",
        },
        {
          value: "选项3",
          label: "信息技术部",
        },
        {
          value: "选项4",
          label: "财务部",
        },
        {
          value: "选项5",
          label: "人力资源部",
        },
      ],
      props: { multiple: true },
      optionsinfo: [
        {
          value: "All",
          label: "全部",
        },
      ],
      optionsAll: [],
      optionsCity: [],
      optionsFac: [],
      optionsBuild: [],
      optionsLab: [],
      RoleTable: [
        {
          id: "",
          roles: "",
          access: "",
          deviceCodes: [],
          normalizedName: "",
        },
      ],
      RoleTablerowNum: 1,
      arr: [],
      arr1: [],
      RoleList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      devicePagination: {
        current: 1,
        pageSize: 20,
        totalPage: 0,
      },
      userId:"",
      deviceTableLoading: false,
      activeColor:'#13ce66',
      activeColor1:'#ff4949',
      loginUserName:'',
      btnType:"",
      loading:false,
      isShowAddBtn:false,
      sfaDeviceList: [],
      CCNheight: "auto",
      emcCustomerList: [],
    };
  },
  created: function () {
    this.authOperation("User");
    this.loginUserName =  getItemFormLocalstorage("userName");
    window.onresize = () => {
      this.setHeight();
    };
  },
  async mounted() {
    this.getUserList();
    this.getRoleList();
    this.getEmcStationProjectList();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasResetPasswordAuth = res.hasResetPasswordAuth;
      that.hasRelieveLockAuth = res.hasRelieveLockAuth;
      that.hasUserActive = res.hasUserActive
      that.hasExportAuth = res.hasExportAuth
      that.hasSyncSfaAuth = res.hasSyncSfaAuth
    },
    reset() {
      this.formselect.queryString = "";
      this.formselect.role = "";
      this.formselect.accountType ="";
      this.getUserList();
    },
    deleteEleById(id) {
      var that = this;
      deleteUser(id).then((res) => {
        if (res.success) {
          that.$message.success(this.$t("tips.deleteSuccess"));
          that.getUserList();
        } else {
          that.$message.error(res.error.message);
        }
      });
    },
    add() {
      this.userform = {
        password: "",
        mobilePhone: "",
        department:"",
        isActive: true,
        roleNames: [],
        accountType:"",
        emcStationProject: ""
      };
      this.RoleTable = [{}];
      this.isShowAddBtn = false;
      this.dialogAddUser = true;
      this.title = this.$t("button.createUser");
      this.userform.password = this.makePassword(8);
      if (this.$refs.userformref != undefined) {
        this.$refs.userformref.resetFields();
      }
    },
    editInfo(e) {
      debugger
      this.title = this.$t("title.editUser");
      this.dialogAddUser = true;
      this.userform = e;
      var arr = [];
      for (let index = 0; index < e.roleNames.length; index++) {
        var obj = {};
        obj.normalizedName = e.roleNames[index];
        arr.push(obj);
      }
      this.RoleTable = arr;
      if (arr && arr.length > 0) {
        this.isShowAddBtn = false;
      }else{
        this.isShowAddBtn = true;
      }
      // e.roleNames.forEach((item, index) => {
      //     this.RoleList.map(i => {
      //         if (item == i.name) {
      //
      //         }
      //     })
      // })
      // this.getpermissionById(e.id).then((res) => {
      //   var arr = [];
      //   for (var i = 0; i < res.roleDataPermissionList.length; i++) {
      //     var obj = {};
      //     obj.id = res.roleDataPermissionList[i].roleId;
      //     this.RoleList.map((item) => {
      //       if (item.id == res.roleDataPermissionList[i].roleId) {
      //         obj.roles = item.dataPermissionType;
      //       }
      //     });
      //     if (obj.roles != "All") {
      //       obj.access =
      //         res.roleDataPermissionList[i].roleDataPermissionStringList;
      //     } else {
      //       obj.access = ["All"];
      //     }
      //     arr.push(obj);
      //   }
      //   this.RoleTable = arr;
      // });
    },
    async getpermissionById(data) {
      var that = this,
        result = "";
      await GetUserRoleListDatapermission(data).then(
        (res) => {
          if (res.success) {
            result = res.result;
          }
        },
        (err) => {
          that.$message.error(this.$t("tips.requestError"));
        }
      );
      return result;
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getUserList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getUserList();
    },
    //分页数据
    deviceHandleCurrentChange(val) {
      this.pagination.current = val;
      this.getSfaUserBindDevices();
    },
    deviceHandleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getSfaUserBindDevices();
    },
    //用户列表
    async getUserList(type = "normal") {
      
      var that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        Keyword: this.formselect.queryString,
        AccountType: this.formselect.accountType,
        //IsActive: true,
        Role: this.formselect.role,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      let data = await getUserByDto(postData);
      this.userInfoList = data.result.items;
      //前台查询分页会有bug
      // if(this.formselect.role!="全部"&&this.formselect.role!=null){
      //   this.userInfoList = this.userInfoList.filter(item=>item.roleNames.some(x=>x==this.formselect.role));
      // }
      this.userInfoList.sort((a, b) => {
        return a.userName - b.userName;
      });
      this.userInfoList.forEach((o) => {
      
        o.isLocked = "否";
        if (
          o.lockoutEndDateUtc != null &&
          o.lockoutEndDateUtc != "" &&
          dateFormat(o.lockoutEndDateUtc, "yyyy-MM-dd HH:mm:ss", 8) >=
            dateFormat(new Date(), "yyyy-MM-dd HH:mm:ss", 0)
        ) {
          o.isLocked = "是";
        }
      });
      //角色名拼接显示在table上
      for (let index = 0; index < that.userInfoList.length; index++) {
        let element = that.userInfoList[index];
        element.roleNameDis = "";
        for (let j = 0; j < element.roleNames.length; j++) {
          element.roleNameDis +=
            that.RoleList.find(
              (item) =>
                item.normalizedName == element.roleNames[j]
            )?.displayName + ",";
        }
        element.roleNameDis = that.userInfoList[
          index
        ].roleNameDis.substring(
          0,
          element.roleNameDis.length - 1
        );
        that.$set(that.userInfoList, index, element);
      }

      this.pagination.totalPage = data.result.totalCount;
    },
    open(msg, title) {
      this.$alert(msg, title, {
        confirmButtonText: this.$t("button.confirm"),
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        },
      });
    },
    async resetPassword(row) {
      let that = this;
      this.$prompt(this.$t("desc.enterAdminPwd"), this.$t("title.tips"), {
        confirmButtonText: this.$t("button.confirm"),
        cancelButtonText: this.$t("button.cancel"),
        inputType: "password",
        inputPattern: /\S/,
        inputErrorMessage: this.$t("desc.enterAdminPwd"),
      })
        .then(({ value }) => {
          let data = { AdminPassword: value, UserId: row.id };
          resetPassword(data)
            .then((res) => {
              this.open(
                this.$t("title.newPassword") + "：" + res.result,
                this.$t("title.resetPassword")
              );
            })
            .catch((err) => {
              that.$message({
                showClose: true,
                message: err.error.message,
                type: "error",
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入",
          // });
        });
    },
    async relieveLock(row) {
      let that = this;
      let data = { UserId: row.id };
      relieveLock(data)
        .then((res) => {
          //   this.open(
          //     this.$t("title.relieveLock") + "：" + res.result,
          //     this.$t("title.relieveLock")
          //   );
          that.getUserList();
          that.$message({
            showClose: true,
            message: $t("title.relieveLockSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    //换页
    async pageChange() {
      this.getUserList();
    },
    //角色列表
    async getRoleList() {
      let data = await getAllRole();
      this.RoleList = data.result.items;
    },
    async getfactoryList() {
      let data = await getFactoryAlls();
      this.factorylist = data.result.items;
      this.getbuildingList();
    },
    async getbuildingList() {
      let data = await GetBuildingAlls();
      this.buildinglist = data.result.items;
      this.getLabList();
    },
    async getLabList() {
      let data = await getLabAll();
      this.lablist = data.result.items;
      this.getOptionsinfo();
    },
    async getEmcStationProjectList() {
      let res = await getStationProjectList();
      this.emcCustomerList = res.result
    },
    //获取权限
    getOptionsinfo(value) {
      var optionsAll = JSON.parse(sessionStorage.getItem("area"));
      var optionsCity = JSON.parse(sessionStorage.getItem("area"));
      var optionsFac = JSON.parse(sessionStorage.getItem("area"));
      var optionsBuild = JSON.parse(sessionStorage.getItem("area"));
      var optionsLab = JSON.parse(sessionStorage.getItem("area"));
      optionsCity.map((i) => {
        delete i.children;
      });
      optionsFac.map((i) => {
        if (i.children.length) {
          i.children.map((j) => {
            delete j.children;
          });
        }
      });
      optionsBuild.map((i) => {
        if (i.children) {
          i.children.map((j) => {
            if (j.children) {
              j.children.map((k) => {
                delete k.children;
              });
            }
          });
        }
      });
      optionsLab.map((i) => {
        if (i.children) {
          i.children.map((j) => {
            if (j.children) {
              j.children.map((k) => {
                if (k.children) {
                  k.children.map((m) => {
                    delete m.children;
                  });
                }
              });
            }
          });
        }
      });
      this.optionsCity = optionsCity;
      this.optionsFac = optionsFac;
      this.optionsBuild = optionsBuild;
      this.optionsLab = optionsLab;
      this.optionsAll = optionsAll;
    },
    async selectChange(value) {
      this.RoleList.map((item, index) => {
        if (value.id == item.id) {
          value.roles = item.dataPermissionType;
        }
      });
    },
    getTypeArr(type) {
      if (type == "Factory") {
        this.allData = this.factorylist; //id为空，取所有列表
        for (var i = 0; i < this.allData.length; i++) {
          var newData = {
            value: this.allData[i].factoryName,
            label: this.allData[i].factoryId,
            children: [],
          };
          // if (stopType != type) {
          //     //获取下级
          //     newData.children = this.getTypeArr(this.nextType(type), this.allData[i].FactoryId, stopType);
          // }
          this.allData.push(newData);
        }
      }
      return this.allData;
    },

    //取到下一个区域
    nextType(type) {
      var regionArr = [
        "Country",
        "City",
        "Factory",
        "Building",
        "Lab",
        "Device",
      ];
      var resi = 0;
      for (var i = 0; i < regionArr.length; i++) {
        resi = i;
        if (regionArr[i] == type) {
          break;
        }
      }
      if (resi == regionArr.length - 1) return -1;
      return regionArr[resi + 1];
    },
    validateEmail(email) {
      // 邮箱验证正则
      var reg = /^[A-Za-z0-9\-]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
      return reg.test(email);
    },
    onSubmit() {
      let isValid = true;
      this.$refs["userformref"].validate((valid) => {
        if (!valid) {
          isValid =false;
        }
      })
      if (!isValid){
        return false;
      }
      this.userform.userName=this.trimStr(this.userform.userName);
      this.userform.name = this.trimStr(this.userform.name);
      this.userform.surname = this.trimStr(this.userform.name);
      this.userform.emailAddress=this.trimStr(this.userform.emailAddress);
      this.userform.accountType = this.trimStr(this.userform.accountType);
      // this.userform.emcStationProject = this.trimStr(this.userform.emcStationProject);
      if (!this.userform.userName || !this.userform.emailAddress) {
        this.$message.warning(this.$t("tips.validate"));
        return;
      }
      if (!this.validateEmail(this.userform.emailAddress)) {
        this.$message.warning(this.$t("tips.enterCorrectEmail"));
        return;
      }
      // var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      // if (!myreg.test(this.userform.mobilePhone)) {
      //   this.$message.warning("手机号码有误，请重填");
      //   return false;
      // }
      if (
        this.RoleTable.length == 1 &&
        this.RoleTable[0].normalizedName == ""
      ) {
        this.$message.warning(this.$t("tips.selectRole"));
        return;
      }
      // if (this.RoleTable[0].access.length == 0) {
      //   this.$message.warning("请选择数据分配！");
      //   return;
      // }
      if (
        this.title != "编辑用户" &&
        this.title != "Edit User" &&
        !this.userform.password
      ) {
        this.$message.warning(this.$t("tips.validate"));
        return;
      }
      var data = this.userform,
        that = this;
      this.userform.roleNames = [];
      for (let index = 0; index < this.RoleTable.length; index++) {
        this.userform.roleNames.push(this.RoleTable[index].normalizedName);
      }

      if (this.title == this.$t("button.createUser")) {
        delete data.id;
        addUser(data)
          .then((res) => {
            if (res.success) {
              that.$message.success(this.$t("tips.createSuccess"));
              that.getUserList();
            } else {
              that.$message.error(res.error.message);
            }
            that.dialogAddUser = false;
          })
          .catch((err) => {
            if (err != undefined) {
              that.$message.error(err.error.message);
            }
          });
      } else {
        var data1 = {
          id: data.id,
          emailAddress: data.emailAddress,
          userName: data.userName,
          password: that.userform.password || "",
          mobilePhone: data.mobilePhone,
          department:data.department,
          roleNames: data.roleNames,
          isActive: true,
          accountType:data.accountType,
          emcStationProject:data.emcStationProject,
          Name: data.name,
          Surname: data.name,
        };
        UpdateUser(data1).then((res) => {
            if (res.success) {
              that.$message.success(this.$t("tips.updateSuccess"));
              that.getUserList();
            } else {
              that.$message.error(res.error.message);
            }
            that.dialogAddUser = false;
          })
          .catch((err) => {
            if (err != undefined) {
              that.$message.error(err.error.message);
            }
          });
      }
    },
    //更新角色权限
    updateRoleDataPermissionList(e) {
      var data = {
        userId: this.userform.id,
        datalist: e,
      };
      UpdateRoleDataPermissionList(data).then((res) => {
        //console.log(res);
      });
    },
    // 增加行  楼宇
    addBuildRow() {
      var list = {
        RoleTablerowNum: this.RoleTablerowNum,
        id: "",
        roles: "",
        access: "",
      };
      this.RoleTable.push(list);
      this.RoleTablerowNum += 1;
      this.isShowAddBtn = false;
    },
    // 删除选中行 楼宇
    delBuildRow(index, row) {
      this.RoleTable.splice(index, 1);
      if (this.RoleTable.length == 0) {
        this.isShowAddBtn = true;
      }
    },
    makePassword(lenth) {
      var str = new Array();
      str[0] = "abcdefghijklmnopqrstuvwxyz";
      str[1] = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      str[2] = "0123456789";
      var result = "";
      var time0 = 0;
      var time1 = 0;
      var time2 = 0;
      for (let index = 0; index < lenth; index++) {
        let strCount = Math.floor(Math.random() * 3); //获取0-3的随机数
        if (strCount == 0) {
          time0++;
          if (time0 > lenth / 3 + 1) {
            strCount = 1;
            if (time1 > lenth / 3 + 1) {
              strCount = 2;
            }
          }
        }
        if (strCount == 1) {
          time1++;
          if (time1 > lenth / 3 + 1) {
            strCount = 2;
            if (time2 > lenth / 3 + 1) {
              strCount = 0;
            }
          }
        }
        if (strCount == 2) {
          time2++;
          if (time2 > lenth / 3 + 1) {
            strCount = 0;
            if (time0 > lenth / 3 + 1) {
              strCount = 1;
            }
          }
        }
        var aaa = Math.floor(Math.random() * str[strCount].length);
        result += str[strCount][aaa];
      }
      return result;
    },
    async exportUserList(){
      let that = this;
      that.loading = true;
      var exportData = [
        [
          that.$t('title.account'),
          that.$t('desc.userName'),
          that.$t('desc.roleName'),
          that.$t('title.emailAddress'),
          that.$t('title.mobilePhone'),
          that.$t('title.accountType'),
          that.$t('title.isLocked'),
          that.$t('title.isActive'),
        ],
      ];

      var fileName = that.$t("exportContent.用户列表") + ".xlsx";
      let skipcount = 0;
      let postData = {
        Keyword: this.formselect.queryString,
        AccountType:this.formselect.accountType,
        //IsActive: true,
        Role: this.formselect.role,
        SkipCount: skipcount,
        MaxResultCount: 999999,
      };
      let res = await getUserByDto(postData);
      let data = res.result.items;
      data.sort((a, b) => {
        return a.userName - b.userName;
      });
      data.forEach((o) => {
      
        o.isLocked = "否";
        if (
          o.lockoutEndDateUtc != null &&
          o.lockoutEndDateUtc != "" &&
          dateFormat(o.lockoutEndDateUtc, "yyyy-MM-dd HH:mm:ss", 8) >=
            dateFormat(new Date(), "yyyy-MM-dd HH:mm:ss", 0)
        ) {
          o.isLocked = "是";
        }
      });
      //角色名拼接显示在table上
      for (let index = 0; index < data.length; index++) {
        data[index].roleNameDis = "";
        for (let j = 0; j < data[index].roleNames.length; j++) {
          data[index].roleNameDis +=
            that.RoleList.find(
              (item) =>
                item.normalizedName == data[index].roleNames[j]
            )?.displayName + ",";
        }
        data[index].roleNameDis = data[
          index
        ].roleNameDis.substring(
          0,
          data[index].roleNameDis.length - 1
        );
      }
      //导入数据里有null会导致文件损坏
      const dataSource = data.map((item) => {
        Object.keys(item).forEach((key) => {
          // 后端传null node写入会有问题
          if (item[key] === null) {
            item[key] = "";
          }

          if (Array.isArray(item[key])) {
            item[key] = item[key].join(",");
          }
        });
        return item;
      });
      dataSource.forEach((item) => {
        let rowData = [];
        rowData = [
          item.userName,
          item.name,
          item.roleNameDis,
          item.emailAddress,
          item.mobilePhone,
          item.accountType == 'sso'? that.$t("desc.ssoAccount"):that.$t("desc.systemAccount"),
          that.$t("desc." + item.isLocked),
          item.isActive? that.$t("desc.yes"):that.$t("desc.no"),
        ];
        exportData.push(rowData);
      });
      exportExcelNew(exportData, fileName);
      // exportExcel(headers, dataSource, fileName);
      that.loading = false;
    },
    //是否激活
    activeSubmit(row){
      
      var data1 = {
          id: row.id,
          emailAddress: row.emailAddress,
          userName: row.userName,
          isActive: row.isActive,
          roleNames: row.roleNames,
          Name: row.name,
          Surname: row.name,
        };
      UpdateUser(data1).then((res) => {
        if (res.success) {
          if(res.result.isActive){
            this.$message.success(this.$t("tips.activeSuccess"));
          }
          if(!res.result.isActive){
            this.$message.success(this.$t("tips.freezingSuccess"));
          }

          //this.getUserList();
        } 
      })
        
    },
    async updateSyncSfaEnable(row){
      try {
        let postData = {
          UserId: row.id,
          SyncSfaEnable: row.syncSfaEnable
        }
        let res = await updateSyncSfaEnable(postData);
        if (res.result.syncSfaEnable == true) {
          this.$message.success(this.$t("desc.syncSfaAuthOpen"));
        }else{
          this.$message.success(this.$t("desc.syncSfaAuthClose"));
        }
      } catch (error) {
        this.$message.error(error.error.message);
      }
      
    },
    async showSfaDevice(visiable, row){
      this.dialogSfaDevice = visiable;
      this.sfaDeviceList = [];
      if (visiable) {
        this.userId = row.id;
        this.devicePagination.current = 1;
        this.devicePagination.totalPage = 0;
        this.setHeight();
        await this.getSfaUserBindDevices()
      }
    },
    async getSfaUserBindDevices(){
      this.deviceTableLoading = true;
      let skipcount = (this.devicePagination.current - 1) * this.devicePagination.pageSize;
      let postData = {
        userId: this.userId,
        language: this.activeLang,
        skipCount: skipcount,
        maxResultCount: this.devicePagination.pageSize,
      }
      try {
        let res = await getSfaUserBindDevices(postData);
        this.sfaDeviceList = res.result.items;
        this.devicePagination.totalPage = res.result.totalCount
        this.deviceTableLoading = false;
      } catch (error) {
        this.deviceTableLoading = false;
      }
      
    },
    trimStr(str){
      str=(str === undefined ? "" : str);
      return str.replace(/(^\s*)|(\s*$)/g,"");
    },
    setHeight() {
      let Height = document.documentElement.clientHeight;
      if (Height > 580) {
        this.CCNheight = document.documentElement.clientHeight * 0.9 - 140;
      } else {
        this.CCNheight = 232;
      }
    },
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
};
</script>

<style>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
